import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { MFilters } from 'types/filterTypes'
import { FilterType } from 'services/types'
import { getFilterInfo } from 'services/utilFunctions/getFilterInfo'
import { currentLang } from 'translations'

// this hook will need to be updated after we refactor getFilterInfo

const useFiltersInfo = (contentName: MFilters.ContentTypes, filters?: string[] | string): FilterType[] => {
  const { userInfo } = useSelector((state: MStore.RootState) => state.users)
  const loggedInUserId = userInfo?._id
  const currentLanguage = currentLang()
  const filterTypes = useMemo(
    () => (filters ? getFilterInfo(filters, loggedInUserId, contentName) : []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filters, loggedInUserId, contentName, currentLanguage]
  )

  return filterTypes
}

export default useFiltersInfo
